var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 24,
    viewBox: "0 0 46 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 5.92487 5.92487 1 12 1H34C40.0751 1 45 5.92487 45 12V12C45 18.0751 40.0751 23 34 23H12C5.92487 23 1 18.0751 1 12V12Z",
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 12C27 8.41015 29.9101 5.5 33.5 5.5C37.0899 5.5 40 8.41015 40 12C40 15.5899 37.0899 18.5 33.5 18.5C29.9101 18.5 27 15.5899 27 12Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleIcon);
export default __webpack_public_path__ + "static/media/toggleIcon.0d93dd4d31c69e84135ef18550f2876d.svg";
export { ForwardRef as ReactComponent };